// Chrome for the authed, non-boat routes (the multi-boat switcher, profile,
// activate). Brand bar + the existing app-shell work area + Neo assistant. Boat
// routes use <BoatShell> instead (which adds the boat-scoped nav + search).

import { Outlet } from 'react-router-dom';

import { NeoChat } from '../NeoChat';
import { BrandBar } from './BrandBar';
import { DemoBanner } from './DemoBanner';

// `neo={false}` leaves the assistant out: a page where the owner decides what
// a third party may do (the OAuth consent screen, TOM-843) has nothing else on
// it, and the floating button would sit over its buttons on a phone.
export function AppShell({ neo = true }: { neo?: boolean }) {
  return (
    <>
      <BrandBar />
      <main className="app-shell">
        <DemoBanner />
        <Outlet />
      </main>
      {neo && <NeoChat />}
    </>
  );
}
